(() => {
const activeDialog = document.querySelector('#active-menu-dialog');
const activeMenuOptions = ['all', 'clothing', 'training', 'wellness'];
let activeMenuTrigger = null;

function selectActiveMenu(value) {
  const selected = activeMenuOptions.includes(value) ? value : 'all';
  for (const tab of activeDialog.querySelectorAll('[data-active-tab]')) tab.setAttribute('aria-pressed', String(tab.dataset.activeTab === selected));
  for (const pane of activeDialog.querySelectorAll('[data-active-pane]')) pane.hidden = selected !== 'all' && pane.dataset.activePane !== selected;
}

function openActiveMenu(trigger) {
  selectActiveMenu(trigger.dataset.activeMenu || 'all');
  if (!activeDialog.open) {
    activeMenuTrigger = trigger;
    for (const dialog of document.querySelectorAll('dialog[open]')) dialog.close();
    activeDialog.showModal();
  }
  for (const button of document.querySelectorAll('[data-active-menu]')) button.setAttribute('aria-expanded', 'true');
  activeDialog.querySelector('[data-active-tab][aria-pressed="true"]')?.focus();
}

if (activeDialog) {
  for (const button of document.querySelectorAll('[data-active-menu]')) {
    button.setAttribute('aria-haspopup', 'dialog');
    button.setAttribute('aria-controls', 'active-menu-dialog');
    button.setAttribute('aria-expanded', 'false');
  }
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-active-menu]');
    if (trigger && !trigger.disabled) { event.preventDefault(); openActiveMenu(trigger); }
    const tab = event.target.closest('[data-active-tab]');
    if (tab && tab.closest('#active-menu-dialog')) selectActiveMenu(tab.dataset.activeTab);
  });
  activeDialog.addEventListener('close', () => {
    for (const button of document.querySelectorAll('[data-active-menu]')) button.setAttribute('aria-expanded', 'false');
    if (activeMenuTrigger?.isConnected && !document.querySelector('dialog[open]')) activeMenuTrigger.focus({preventScroll:true});
    activeMenuTrigger = null;
  });
  selectActiveMenu('all');
}
})();
